import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Crown } from "lucide-react";

const SECTIONS = [
  { h: "1. Acceptance of terms", p: "By creating an account or using Carlocs Scalp Analyzer (\"the Service\"), operated by Carlocs Group, you agree to these Terms of Use. If you do not agree, please do not use the Service." },
  { h: "2. Nature of the Service", p: "The Service provides expert observations about scalp and loc health based on a photo and questionnaire you submit. It is for informational and cosmetic guidance only and does not constitute medical, dermatological, or professional advice, diagnosis, or treatment." },
  { h: "3. No medical reliance", p: "You should not rely on the Service for medical decisions. If you experience pain, infection, significant hair loss, or any health concern, consult a qualified healthcare professional." },
  { h: "4. Payments", p: "Scan fees are payable per scan (R79) and are processed by our third-party payment provider, iKhokha. Fees are for the analysis service and are non-refundable once a report has been generated." },
  { h: "5. Accounts", p: "You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. Provide accurate information when registering." },
  { h: "6. Acceptable use", p: "You agree to upload only photos of your own scalp/locs (or with the subject's consent) and not to misuse, reverse-engineer, or disrupt the Service." },
  { h: "7. Intellectual property", p: "All branding, content, and software are owned by Carlocs Group. Your uploaded photos remain yours; you grant us a limited licence to process them to deliver your report." },
  { h: "8. Limitation of liability", p: "To the maximum extent permitted by law, Carlocs Group is not liable for any indirect or consequential loss arising from use of the Service. The Service is provided \"as is\"." },
  { h: "9. Changes", p: "We may update these Terms from time to time. Continued use after changes constitutes acceptance." },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-charcoal text-cream">
      <Navbar />
      <div className="mx-auto max-w-3xl px-6 py-14" data-testid="terms-page">
        <span className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold"><Crown className="h-4 w-4" /> Legal</span>
        <h1 className="mt-2 font-heading text-4xl text-cream md:text-5xl">Terms of Use</h1>
        <p className="mt-2 text-sm text-muted-foreground">Draft — subject to final review. Last updated {new Date().getFullYear()}.</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h2 className="mb-2 font-heading text-2xl text-cream">{s.h}</h2>
              <p className="text-sm leading-relaxed text-muted-foreground">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
